<template>
    <div class="form-field form-numeric" :rel="name" v-bind:class="{'has-suffix': suffix, 'form-required': requiredForm}">
        <div class="form-label" v-show="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <button @click="removeOne()"><span class="icon icon-icon_minus"></span></button>
                <input type="number" :step="stepValue" value="0" v-model="internalValue" :placeholder="placeholder"/>
                <button @click="addOne()"><span class="icon icon-icon_plus"></span></button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['value','label','name','placeholder','suffix', 'step','required','default'],
        data: function () {
            return {
                internalValue: '',
                oneTime: null
            }
        },
        created: function() {
            this.internalValue = 0;
            this.stepValue = this.step ? this.step : 1
            this.requiredForm = this.required && this.required == 'true' ? true : false
            this.defaultValue = this.default;
        },
        methods: {
            removeOne: function(){
                this.internalValue = parseInt(this.internalValue) ? parseInt(this.internalValue) : 0
                this.internalValue = parseInt(this.internalValue) - 1
            },
            addOne: function(){
                this.internalValue = parseInt(this.internalValue) ? parseInt(this.internalValue) : 0
                this.internalValue = parseInt(this.internalValue) + 1
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal;
                this.internalValue = this.internalValue == 0 || !this.internalValue ? this.defaultValue : this.internalValue;
            },
            'internalValue'(newVal, oldVal) {
                if( newVal ){
                    let diff = Math.round(newVal%this.stepValue*100)/100
                    diff = diff >= this.stepValue ? 0 : diff
                    //console.log(newVal, this.stepValue, Math.round(newVal%this.stepValue*100)/100)
                    this.internalValue = newVal - diff;
                    this.internalValue = this.internalValue == 0 || !this.internalValue ? this.defaultValue : this.internalValue;
                }
                console.log("Log:", this.internalValue)
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Numeric.vue